export enum LOCAL_STORAGE {
  sidebarAdmin = "sidebarAdmin",
}
